"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDataToGeneralSchema = void 0;
const lists_1 = require("src/lists");
const NOT_AVAILABLE_DATA = 'N/A';
const transformDataToGeneralSchema = (data) => {
    if (!data || data.length === 0) {
        return [];
    }
    return data
        .map(course => {
        const courseType = course.type && course.type !== NOT_AVAILABLE_DATA ? course.type : '';
        const duration = course.duration && course.duration !== NOT_AVAILABLE_DATA ? course.duration : '';
        const transformedObject = Object.assign(Object.assign({}, course), { name: (0, lists_1.getFirstOrDefault)(course.name, ''), type: courseType, duration: duration, description: (0, lists_1.getFirstOrDefault)(course.description, '') });
        // Business logic: do not show rows without name and description
        if (!transformedObject.name && !transformedObject.description)
            return;
        return transformedObject;
    })
        .filter(course => course)
        .sort((a, b) => a.name.localeCompare(b.name));
};
exports.transformDataToGeneralSchema = transformDataToGeneralSchema;
